if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentMediaIndex = 0;
        this.handleKeydown = this.handleKeydown.bind(this);
      }

      hide() {
        document.removeEventListener('keydown', this.handleKeydown);
        super.hide();
      }

      show(opener) {
  super.show(opener);

  if (window.innerWidth < 990) {
    this.showOriginalMobileMedia();
    return;
  }

  this.setupGallery();
  this.showActiveMedia();
  document.addEventListener('keydown', this.handleKeydown);
}
showOriginalMobileMedia() {
  this.querySelectorAll(
    `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
  ).forEach((element) => {
    element.classList.remove('active');
  });

  const activeMedia = this.querySelector(
    `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
  );

  if (!activeMedia) return;

  activeMedia.classList.add('active');
  activeMedia.scrollIntoView();

  const container = this.querySelector('[role="document"]');
  container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
}

      setupGallery() {
        if (window.innerWidth < 990) return;
        this.mediaItems = Array.from(
          this.querySelectorAll('.product-media-modal__content > [data-media-id]')
        );

        if (!this.mediaItems.length) return;

        this.mediaItems.forEach((item) => {
          item.style.display = 'none';
        });

        if (!this.querySelector('.product-modal-nav--prev')) {
          const prevButton = document.createElement('button');
          prevButton.type = 'button';
          prevButton.className = 'product-modal-nav product-modal-nav--prev';
          prevButton.setAttribute('aria-label', 'Previous image');
          prevButton.innerHTML = '&#10094;';
          prevButton.addEventListener('click', (event) => {
  event.preventDefault();
  event.stopPropagation();
  this.changeMedia(-1);
});
prevButton.addEventListener('pointerup', (event) => {
  event.stopPropagation();
});

          const nextButton = document.createElement('button');
          nextButton.type = 'button';
          nextButton.className = 'product-modal-nav product-modal-nav--next';
          nextButton.setAttribute('aria-label', 'Next image');
          nextButton.innerHTML = '&#10095;';
          nextButton.addEventListener('click', (event) => {
  event.preventDefault();
  event.stopPropagation();
  this.changeMedia(1);
});
nextButton.addEventListener('pointerup', (event) => {
  event.stopPropagation();
});

          this.querySelector('.product-media-modal__dialog').appendChild(prevButton);
          this.querySelector('.product-media-modal__dialog').appendChild(nextButton);
        }
      }

      showActiveMedia() {
        if (!this.mediaItems?.length) return;

        const mediaId = this.openedBy.getAttribute('data-media-id');

        let index = this.mediaItems.findIndex(
          (item) => item.getAttribute('data-media-id') === mediaId
        );

        if (index === -1) index = 0;

        this.currentMediaIndex = index;
        this.displayCurrentMedia();
      }

      displayCurrentMedia() {
        this.mediaItems.forEach((item, index) => {
          item.style.display =
            index === this.currentMediaIndex ? '' : 'none';
          item.classList.toggle('active', index === this.currentMediaIndex);
        });

        const activeMedia = this.mediaItems[this.currentMediaIndex];
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      changeMedia(direction) {
        if (!this.mediaItems?.length) return;

        this.currentMediaIndex =
          (this.currentMediaIndex + direction + this.mediaItems.length) %
          this.mediaItems.length;

        this.displayCurrentMedia();
      }

      handleKeydown(event) {
        if (event.key === 'ArrowLeft') {
          this.changeMedia(-1);
        }

        if (event.key === 'ArrowRight') {
          this.changeMedia(1);
        }
      }
    }
  );
}